import classNames from 'classnames';
import React, {ComponentProps, ReactElement, useCallback, useMemo} from 'react';

import Row from '../../../common/Row';
import {useBreakpoint} from '../../../common/util/useBreakpoint';
import {MarketplaceCropType} from '../../../query/graphql';
import Button from '../buttons/Button';
import GenericCard from '../GenericCard';
import MultiSelect from '../MultiSelect';

type Props = {
  allCrops: MarketplaceCropType[];
  selectedIds: string[]; // Strapi crop type IDs
  onChange: (selected: string[]) => void;
  className?: string;
};

const SearchByCropTypeBox = ({allCrops, selectedIds, onChange, className}: Props): ReactElement => {
  const {isMobile} = useBreakpoint('mobile');

  const handleClear = useCallback(() => {
    onChange([]);
  }, [onChange]);

  return (
    <GenericCard border={'light'} className={classNames('p-sm flex flex-col gap-xs !overflow-visible', className)}>
      <Row className={'items-center justify-between'}>
        <span>Crop types</span>
        <Button variant={'link'} onClick={handleClear}>
          <span className={'text-xs'}>Clear All {!!selectedIds.length && `(${selectedIds.length})`}</span>
        </Button>
      </Row>
      <SearchByCropTypeBox.Dropdown
        allCrops={allCrops}
        selectedIds={selectedIds}
        onChange={onChange}
        noSelectionLabel={'Select crop types'}
        asModal={isMobile}
      />
    </GenericCard>
  );
};

SearchByCropTypeBox.Dropdown = function Dropdown({
  allCrops,
  selectedIds,
  onChange,
  className,
  noSelectionLabel,
  asModal,
  withClearAll,
}: Props & Pick<ComponentProps<typeof MultiSelect>, 'noSelectionLabel' | 'asModal' | 'withClearAll'>): ReactElement {
  const options = useMemo(() => allCrops.map(crop => ({label: crop.name, value: crop.id})), [allCrops]);

  return (
    <MultiSelect
      options={options}
      selectedValues={selectedIds}
      onChange={onChange}
      noSelectionLabel={noSelectionLabel}
      className={className}
      asModal={asModal}
      withClearAll={withClearAll}
      heading={asModal ? 'Select crop types' : undefined}
    />
  );
};

export default SearchByCropTypeBox;
